module.exports = __webpack_public_path__ + "img/illus_tutorial_2@2x.432caa46.png";